import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { QuoteEmailLandingComponent } from './pages/quote-email-landing/quote-email-landing.component';
import { QuoteEmailUpdateComponent } from './pages/quote-email-update/quote-email-update.component';

const routes: Routes = [
  {
    path: 'quote',
    component: QuoteEmailLandingComponent
  },
  {
    path: 'update',
    component: QuoteEmailUpdateComponent
  },
  {
    path: '',
    component: QuoteEmailLandingComponent
  }
];

@NgModule({
  declarations: [],
  imports: [[RouterModule.forChild(routes)]],
  exports: [RouterModule]
})
export class EmailLandingRoutingModule {}
